document.querySelector('.cart__checkout')?.addEventListener("click", function(e) {
  e.preventDefault();
   checkCart();
  });


   function  checkCart(){
     console.log('check cart');
     var productsToUpdate = [];
      var productsToAdd = [];
   
       fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => { 
        var cartContents = data;
        var cartItems = data.items;

        if (cartItems.length > 0){
          cartItems.forEach((i) => {
            if (typeof i.properties['_options_addon_products'] != 'undefined'){
              var optionsGuid = i.properties['_options_group_id'];
              var optionsQty = i.quantity;
              var addOns = JSON.parse(i.properties['_options_addon_products']);
              addOns.forEach((a) => {
                var ext = cartItems.filter((x)=> x.variant_id == a.variantId && x.properties['_options_action'] == a.actionID && x.properties['_options_group_id']==optionsGuid);
                if(ext.length == 1){
                  //check quantity
                  if (ext[0].quantity != optionsQty){
                    
                    var p = {
                      key: ext[0].key,
                      quantity: optionsQty
                    }
                    productsToUpdate.push(p);
                  }
                }
                if(ext.length == 0){
                  var product = {
                      quantity: optionsQty,
                      id: a.variantId,
                      properties: {
                          "_options_group_id": optionsGuid,
                          "_options_hidden": 'true',
                          "_options_action": a.actionID
                      }
                  }
                  productsToAdd.push(product);
                }
              });
            }
          });

         updateCart(productsToUpdate, productsToAdd)

        }
      })
   }
   
   function updateCart(productsToUpdate, productsToAdd){
     console.log('update cart');
     
     Promise.allSettled([
        addProducts(productsToAdd),
        updateProducts(productsToUpdate)
      ]).then((results) =>{
       window.location.href = "/checkout";
     }).catch(err =>
        console.log(err)
      );
   }


   function addProducts(productList){
     console.log('add products');
      if(productList.length <= 0){return null;}
     
      let formData = {
         'items': productList
        };

       return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
          })
          .then((response)=>response.json())
          .then((responseJson)=>{return responseJson})
          .catch((error) => {
            console.error('Error:', error);
          });
   }

   function updateProducts(updateList){
      console.log('update products');
     if(updateList.length <= 0){return null;}
     
     var formData = new FormData();
     updateList.forEach((u) => {
       formData.append("updates[" + u.key + "]", u.quantity);
     });
     
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body:  formData
      })
      .then(response => response.json())
      .then(data => {return data})
      .catch((error) => {
        console.error('Error:', error);
      });
   }
